import { getCachedValue, setCachedValue } from '../api/cacheService';

const RESPONSE_CACHE_PREFIX = 'nlims_offline_response:';

function buildCacheKey(config = {}) {
  const method = String(config.method ?? 'get').toLowerCase();
  const url = String(config.url ?? '').trim();
  const params = config.params ? JSON.stringify(config.params) : '';
  return `${RESPONSE_CACHE_PREFIX}${method}:${url}:${params}`;
}

function cacheResponse(response) {
  const key = buildCacheKey(response?.config ?? {});
  if (!key) return;
  setCachedValue(key, {
    data: response.data,
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  });
}

function readCachedResponse(config) {
  const cached = getCachedValue(buildCacheKey(config));
  if (!cached?.value) return null;

  return {
    data: cached.value.data,
    status: cached.value.status ?? 200,
    statusText: cached.value.statusText ?? 'OK',
    headers: cached.value.headers ?? {},
    config,
  };
}

export function installOfflineInterceptors(instance) {
  if (!instance?.interceptors) return;

  instance.interceptors.response.use(
    (response) => {
      if (String(response?.config?.method ?? 'get').toLowerCase() === 'get') {
        cacheResponse(response);
      }
      return response;
    },
    (error) => {
      const config = error?.config;
      const method = String(config?.method ?? '').toLowerCase();
      const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;

      if (isOffline && method === 'get') {
        const cachedResponse = readCachedResponse(config);
        if (cachedResponse) return Promise.resolve(cachedResponse);
      }

      return Promise.reject(error);
    }
  );
}

